import React, { useState } from 'react';

const EyeIcon = ({ open }) => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
    {open ? (
      <>
        <path d="M2 10s3.582-6 8-6 8 6 8 6-3.582 6-8 6-8-6-8-6z" />
        <circle cx="10" cy="10" r="2.5" />
      </>
    ) : (
      <>
        <path d="M3 3l14 14" />
        <path d="M8.2 4.3A8.6 8.6 0 0110 4c4.418 0 8 6 8 6a14.6 14.6 0 01-2.6 3.2M5.4 5.6C3.3 7.1 2 10 2 10s3.582 6 8 6a8 8 0 003.5-.8" />
        <path d="M8.2 8.3a2.5 2.5 0 003.5 3.5" />
      </>
    )}
  </svg>
);

const baseInputStyle = {
  width: '100%',
  padding: '0.75rem 2.75rem 0.75rem 0.85rem',
  border: '1px solid #CBD5E1',
  borderRadius: 8,
  fontSize: '1rem',
  color: '#0F172A',
  background: '#FFFFFF',
  boxSizing: 'border-box'
};

const PasswordInput = ({ style, inputStyle, id, ...inputProps }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div style={{ position: 'relative', width: '100%', ...style }}>
      <input
        id={id}
        {...inputProps}
        type={visible ? 'text' : 'password'}
        style={{ ...baseInputStyle, ...inputStyle }}
      />
      <button
        type="button"
        onClick={() => setVisible((value) => !value)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-controls={id}
        style={{
          position: 'absolute',
          right: 8,
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'transparent',
          border: 0,
          padding: 6,
          cursor: 'pointer',
          color: '#64748B',
          display: 'flex'
        }}
      >
        <EyeIcon open={!visible} />
      </button>
    </div>
  );
};

export default PasswordInput;
